<template>
  <div class="section-card contact-card">
    <div class="card-header green-bar">
      <div style="display:flex;align-items:center;gap:8px;">
        <v-icon color="#10b981">contacts</v-icon>
        <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Hotel-Contact-Information') }}</span>
      </div>
    </div>
    <div class="card-body">
      <v-layout row wrap>
        <v-flex xs12 sm3 pr-1>
          <v-text-field
            :label="$t('Name_label')"
            v-model="contact.Name"
            :rules="[rules.required]"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 pr-1>
          <v-text-field
            :label="$t('Surname_label')"
            v-model="contact.LastName"
            :rules="[rules.required]"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 pr-1>
          <v-text-field
            :label="$t('Telephone')"
            v-model="contact.Phone"
            :rules="[rules.required]"
            outline
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field
            :label="$t('Email_label')"
            v-model="contact.Email"
            :rules="[rules.required, rules.email]"
            outline
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "HotelContactCard",
  props: {
    contact: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.green-bar {
  border-top-color: #10b981;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}
</style>
